module.exports = __webpack_public_path__ + "img/opinionRating.252ce5bb.png";